<template>
   <a v-if="isExternal" :href="urlWithParams" class="inline-block" :target="target"
      ><slot v-if="!text"></slot>{{ text }}</a
   >
   <router-link v-else :to="urlWithParams" class="inline-block" :target="target"
      ><slot v-if="!text"></slot>{{ text }}</router-link
   >
</template>

<script setup lang="ts">
import { useRouteLocale } from "@/composables/useRouteLocale";

export interface LinkElementData {
   type: "link";
   url: string;
   text?: string; // can be passed via slot
   isExternal?: boolean;
   target?: "_self" | "_blank" | null;
}

const { localePath } = useRouteLocale();

const props = defineProps<LinkElementData>();

const urlWithParams = computed(() => {
   if (!props) return null;

   if (!props.isExternal && !props.url.startsWith("mailto")) {
      // ex: localepath= "/en-gb" + props.url = "/account"
      const optionalSlash = props.url.startsWith("/") ? "" : "/";
      return `${localePath.value}${optionalSlash}${props.url}`;
   }
   return props.url;
});
</script>

<style scoped></style>
